import routingPageScroll from './page/middleware/routingPageScrollMiddleware';

export default [routingPageScroll];
